import { FlutterFromStrategyIcon } from '@/svgs'
import React from 'react'

function FlutterFromStrategy() {
   return (
      <section id="development-guide-section" className="cs-bg-theme-color-2">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Idea to Execution:
               <br />
               Our Flutter Development Process
            </h2>

            <p className="section_desc">
               We have been working with Flutter for over 12 years and have
               built all kinds of apps along the way. We do not just jump into
               coding without a plan. First, we take the time to understand what
               you actually need and put together a roadmap that makes sense.
               When launch time comes, everything is built to work right and
               last long. Our Flutter solutions help you deliver native-like
               experiences, speed up development, and stay ahead of the
               competition. Let’s build seamless cross-platform apps that your
               users will love.
            </p>

            <FlutterFromStrategyIcon />
         </div>
      </section>
   )
}

export default FlutterFromStrategy
